"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decomposePath_1 = __importDefault(require("./decomposePath"));
var uniq_1 = __importDefault(require("uniq"));
// Implement https://en.wikipedia.org/wiki/Tarjan%27s_strongly_connected_components_algorithm for faster search
var extendDeps = function (deps) {
    return Object.keys(deps).reduce(function (acc, x) {
        acc[x] = deps[x];
        (0, decomposePath_1.default)(x).forEach(function (y) {
            //@ts-ignore
            acc[y] = deps[x];
        });
        return acc;
    }, {});
};
exports.default = (function (deps) {
    deps = extendDeps(deps);
    var parents = Object.keys(deps);
    var willVisit = parents.reduce(function (acc, x) {
        acc[x] = false;
        return acc;
    }, {});
    var isCyclic = false;
    root: for (var i = 0; i < parents.length; i += 1) {
        var visited = Object.assign({}, willVisit);
        var parent_1 = parents[i];
        var children = deps[parent_1].slice();
        while (children.length > 0) {
            var child = children.shift();
            if (deps[child]) {
                if (visited[child]) {
                    isCyclic = true;
                    break root;
                }
                else {
                    visited[child] = true;
                    children = children.concat(deps[child]);
                    children = (0, uniq_1.default)(children);
                }
            }
            else {
                // Its a static node so we don't care
            }
        }
    }
    return isCyclic;
});
//# sourceMappingURL=data:application/json;base64,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